module.exports = __webpack_public_path__ + "img/darklogo.b68dbb3d.png";